import React, { useState, useEffect } from 'react'
import { GetCollection, GetDocument } from '../../../../firebase/firebase'
import { Card, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
export const RecipeCategoryWrapper = (props) => {
    const categoryId = props.id
    const [recipes, setRecipes] = useState([])
    const [category, setCategory] = useState('')
    useEffect(() => {
        GetCollection('recipes', true, 'category', categoryId).then((data) => {
            setRecipes(data.docs.map((doc) => doc.data()))
        })

        GetDocument('recipeCategories', categoryId).then((data) => {
            setCategory(data.data())
        })

    }, [])
    return (
        <>
            <Row className='d-flex justify-content-center align-items-center'>
                <Col className='d-flex justify-content-center align-items-center'>
                    <h4>{category.title}</h4>
                </Col>
            </Row>
            <Row className='d-flex justify-content-center align-items-center'>
                <Col className='d-flex justify-content-center align-items-center'>
                    <h4>{category.description}</h4>
                </Col>
            </Row>
            <RecipeCardList recipes={recipes} />
        </>
    )
}

const RecipeCardList = (props) => {
    const recipes = props.recipes
    return (
        <>
            <Row>

                {recipes && recipes.map((recipe, i) => {
                    return (
                        <Col md={3} key={i}>
                            <RecipeCard recipe={recipe} />
                        </Col>
                    )
                })}
            </Row>
        </>
    )
}

const RecipeCard = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Card className='h-100'>
                <Card.Img variant='top' src={recipe.image} style={{ height: '275px', width: 'auto' }} />
                <Card.Header>
                    {recipe.title}
                </Card.Header>
                <Card.Body>

                    {recipe.description}
                </Card.Body>
                <Card.Footer>
                    <Link to={`/recipes/view/${recipe.id}`}>
                        View
                    </Link>
                </Card.Footer>
            </Card >
        </>
    )
}